// extracted by mini-css-extract-plugin
module.exports = {"langWrapper":"styles_langWrapper__Fb8X0","langButton":"styles_langButton__7sCTT","langDropdown":"styles_langDropdown__KCcDf","visible":"styles_visible__il3UK"};